import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightHide32Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSidebarRightHide32Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 8H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12zm2 18h4c1.12 0 2.132-.46 2.858-1.201H28v-.153c.622-.705 1-1.632 1-2.646V10a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4zM10.485 13.167a1 1 0 0 1 1.415-1.414l3.535 3.535.707.707-.707.708-3.536 3.535a1 1 0 0 1-1.414-1.414l2.829-2.829z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightHide32Filled);
